import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

const Amount = types.model('Amount', {
  currency: types.optional(types.string, 'INR'),
  feeamount: types.optional(types.string, '0'),
  grossAmount: types.optional(types.string, '0'),
  netAmount: types.optional(types.string, '0'),
  payableAmount: types.optional(types.string, '0'),
  conFee: types.optional(types.string, '0'),
  amountToLoad: types.optional(types.string, '0'),
})

export { Amount }
export type AmountType = Instance<typeof Amount>
